import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import type { Reference } from '@eliadmin/core/src/api/references/references-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { ReferenceDownloadButton } from './reference-download-button';

export const ReferenceCard = ({ reference }: { reference: Reference }) => {
  return (
    <div className={cn('relative col-span-1 flex w-full flex-col items-start justify-start gap-6')}>
      <Link
        prefetch={false}
        href={reference?.firstname ?? '#'}
        target="_blank"
        className="relative h-[330px] w-full overflow-hidden rounded-[24px] sm:h-[375px] md:rounded-[48px]"
      >
        <Image
          src={reference.image.url ?? '/images/placeholder.png'}
          alt={resolveImageAlt(reference?.image, reference?.name)}
          fill
          style={{ objectFit: 'cover', objectPosition: 'center' }}
          sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
        />
      </Link>
      <div className="flex w-full items-center justify-between gap-3">
        <div className="flex w-full flex-col gap-2">
          <div className="flex w-full items-center justify-start">
            {reference?.categories?.map(category => (
              <span key={category.name} className="text-base lowercase text-[#197CB1]">
                /{category.name}&nbsp;
              </span>
            ))}
          </div>
          <h2 className="text-xl font-bold text-foreground">{reference.name}</h2>
        </div>
        {reference.sheet !== null && <ReferenceDownloadButton reference={reference} />}
      </div>
    </div>
  );
};
